import React, { useState, useEffect } from "react";
import '../../../../assets/css/app-google-review-module.css';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Tooltip } from "react-tooltip";
import { toast } from 'react-toastify';
import { updateReview,getSingleReviewTemplateDetail } from "../../../../utils/reviewApi";

//Import Tabs
import SourceTab from "../../../../components/Apps/CapterraReviews/SourceTab";
import LayoutTab from "../../../../components/Apps/CapterraReviews/LayoutTab";
import HeaderTab from "../../../../components/Apps/CapterraReviews/HeaderTab";
import ReviewTab from "../../../../components/Apps/CapterraReviews/ReviewTab";
import StyleTab from "../../../../components/Apps/CapterraReviews/StyleTab";
import SettingTab from "../../../../components/Apps/CapterraReviews/SettingTab";

//Import Widgets
import CommonTemplate from "../../../../components/Apps/CapterraReviews/Template/CommonTemplate";

export default function EditCapterraReview() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeSection, setActiveSection] = useState("Source");
    const [activeTemplateSection, setActiveTemplateSection] = useState("");
    const [selectedLayout, setSelectedLayout] = useState("");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Capterra Reviews");
    const [newWidgetName, setNewWidgetName] = useState("");
    const { uuid } = useParams();
    const [isTemplateId, setTemplateId] = useState(null); 
    
    const [reviewTabData, setReviewTabData] = useState({
        is_website_frontend: "", 
        business_name: "",   
        layout_is_full_width: 0,     
        layout_custom_width: "1280",  
        layout_columns: "Auto",    
        layout_rows: 3,    
        layout_rows_on_mobile: 3,    
        layout_item_spacing: 10,    
        header_is_show_header: 1,    
        header_show_header_style: "",    
        header_source_icon: 1,    
        header_rating: 1,    
        header_number_of_reviews: 1,    
        header_write_reviews_button: 1,  
        header_is_widget_title: 1,    
        header_title: "Capterra Reviews",    
        header_caption: "",   
        header_write_review_button_type: "medium", 
        review_style: "",    
        review_source_style: "",    
        review_is_show_reviewer_name: 1,    
        review_is_show_reviewer_picture: 1,    
        review_is_show_verified_badge: 1,    
        review_is_show_review_source: 1,    
        review_is_show_date: 1,    
        review_is_show_rating: 1,    
        review_is_show_images: 1,    
        review_is_show_business_owner_reply: 1,  
        review_reviewer_name_format: "",      
        review_how_to_display_review_text: "",      
        style_color_scheme_type: "light",      
        style_accent_color: "",      
        style_background_color: "",      
        style_widget_title_alignment: "",      
        style_widget_title_color: "",      
        style_widget_title_caption_color: "",      
        style_widget_title_links_color: "",      
        style_widget_title_fonts_title_size: "20px",        
        style_widget_title_fonts_caption_size: "14px",      
        style_header_background_color: "",      
        style_header_text_color: "",      
        style_header_write_review_background_color: "",      
        style_header_write_review_text_color: "",      
        style_header_source_icon_color: "",      
        style_rating_stars_color: "",
        style_review_background_color: "",         
        style_review_outline_color: "",         
        style_review_text_color: "",         
        style_read_more_color: "",         
        style_review_reviewer_name_color: "",         
        style_review_verified_badge_color: "",         
        style_review_date_color: "",         
        style_review_source_icon_color: "",         
        style_review_source_icon_background_color: "",         
        style_review_rating_size: "Medium",         
        style_review_text_font_size: "16px",         
        style_load_more_button_color: "",         
        style_load_more_button_text_color: "",         
        style_custom_css: "",         
        setting_is_enable_external_links: 1,         
        setting_is_open_links_in_new_tab: 0,         
        setting_rating_format: "4.9",         
        setting_custom_js: "",  
    });
    
    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateReviewTabData = (key, value) => {
        setReviewTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const menuItems = [
        { key: "Source", icon: "source.png", label: "Source" },
        { key: "Layout", icon: "layout.png", label: "Layout" },
        { key: "Header", icon: "header.png", label: "Header" },
        { key: "Review", icon: "review.png", label: "Review" },
        { key: "Style", icon: "style.png", label: "Style" },
        { key: "Settings", icon: "setting.png", label: "Settings" },
    ];

    // Handle Layout Change
    const handleLayoutChange = (e) => {
        let layout_name = e.target.value;
        setSelectedLayout(layout_name);

        //check template layouts
        if(layout_name === "carousel_layout"){
            setSelectedTemplateImage("carousel-widgets.png");
        } else if(layout_name === "grid_layout"){
            setSelectedTemplateImage("grid-with-ai-summary-widget.png");
        } else if(layout_name === "list_layout"){
            setSelectedTemplateImage("grid-with-ai-summary-widget.png");
        } else if(layout_name === "masonry_layout"){
            setSelectedTemplateImage("grid-with-ai-summary-widget.png");
        } else if(layout_name === "badge_layout"){
            setSelectedTemplateImage("badge-widgets.png");
        } else if(layout_name === "floating_badge_layout"){
            setSelectedTemplateImage("floating-badge-widgets.png");
        } else if(layout_name === "slider_layout"){
            setSelectedTemplateImage("slider-widgets.png");
        }
    };

    //Submit Review data
    const updateReviewForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try { 
            const extractedImageName = selectedTemplateImage.split('/').pop();

            // Convert settings object back into an array of key-value pairs
            const settingsArray = Object.entries(reviewTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));
            
            // Collect data from refs
            const payload = {
                template_id: uuid,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: extractedImageName,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                business_name: reviewTabData.business_name,
                app_type: "Capterra_Review",
                settings: settingsArray,
            };

            //Api Call
            let api_response = await updateReview(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success("Review update successfully! ");
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/capterra-reviews');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    // Fetching Tempate Review data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getSingleReviewTemplateDetail(uuid);

                //check if result is exitys
                if (templateResult.data) {
                    setTemplateId(uuid);
                    setWidgetName(templateResult.data.name); 
                    setActiveTemplateSection(templateResult.data.template_name);
                    setSelectedLayout(templateResult.data.layout_type);
                    setSelectedTemplateImage(templateResult.data.template_image);
                    // Convert settings array to object
                    const settingsObject = templateResult.data.settings.reduce((acc, setting) => {
                        acc[setting.setting_key] = setting.setting_value;
                        return acc;
                    }, {});
                    setReviewTabData(settingsObject);
                    updateReviewTabData("business_name", templateResult.data.business_name); 
                }
            } catch (error) { 
                //console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [uuid,setReviewTabData]);

    return (
        <>
            <div className="create-goole-reviews-all">
                <div className="overlay-side-baar">
                    <div className="side-baar-inner-one">
                        <ul>
                            {menuItems.map((item) => (
                                <li key={item.key}>
                                    <button
                                        className={activeSection === item.key ? "active" : ""}
                                        onClick={() => setActiveSection(item.key)}
                                    >
                                        <img
                                            src={`${process.env.PUBLIC_URL}/capterra-reviews/icons/${item.icon}`}
                                            alt={`${item.key} icon`}
                                        />
                                        <span>{item.label}</span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="side-baar-inner-tow">
                        {/* Conditional Rendering for Sections */}
                        {activeSection === "Source" && (
                            <SourceTab updateReviewTabData={updateReviewTabData} reviewTabData={reviewTabData} />
                        )}
                        {activeSection === "Layout" && (
                            <LayoutTab handleLayoutChange={handleLayoutChange} selectedLayout={selectedLayout} updateReviewTabData={updateReviewTabData} reviewTabData={reviewTabData} />
                        )}
                        {activeSection === "Header" && (
                            <HeaderTab updateReviewTabData={updateReviewTabData} reviewTabData={reviewTabData} />
                        )}
                        {activeSection === "Review" && (
                            <ReviewTab updateReviewTabData={updateReviewTabData} reviewTabData={reviewTabData} />
                        )}
                        {activeSection === "Style" && (
                            <StyleTab updateReviewTabData={updateReviewTabData} reviewTabData={reviewTabData} />
                        )}
                        {activeSection === "Settings" && (
                            <SettingTab updateReviewTabData={updateReviewTabData} reviewTabData={reviewTabData} />
                        )}
                    </div>
                </div>
                <div className="create-goole-reviews-right">
                    <div className="content-wrapper">
                        <div className="source-header-row">
                            <h2><Link to="/customer/apps/capterra-reviews"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                            <div className="untitled-widget-name">
                                <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/capterra-reviews/capterra-reviews.svg`} alt="capterra-reviews"/>{ widgetName }</button>
                                <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                            </div>
                            <div className='submit-google-review'>
                                <button type="button" onClick={updateReviewForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Update</button>
                                <Link to="/customer/apps/capterra-reviews/pricing/single" className="view-plan">View Plans</Link>
                                <Link to="/customer/apps/capterra-reviews">Close</Link>
                            </div>
                        </div>
                        <div className="source-title-row">Capterra Reviews <img src={`${process.env.PUBLIC_URL}/images/icon-24.png`} alt="icon-24" /> <strong>Source</strong></div>

                        {/*Call Common template*/}
                        <CommonTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} isTemplateId={isTemplateId} reviewTabData={reviewTabData} /> 
                    </div>
                </div>
            </div>

            {/* Rename Popup */}
            {renameWidgetNameModel && (
                <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                    <div className="bg-white p-3 rounded-lg shadow-lg">
                        <h3 className="text-lg font-semibold">Rename Widget</h3>
                        <label>Widget Name</label>
                        <input
                            type="text"
                            className="border p-2 w-full mt-2"
                            value={newWidgetName}
                            onChange={(e) => setNewWidgetName(e.target.value)}
                        />
                        <div className="mt-3 flex justify-end">
                            <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                                Cancel
                            </button>
                            <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}